<script setup>
import { ref, onMounted, computed } from "vue";
import { useRequestsStore } from "@/stores/storeRequests";
import { useDishesStore } from "@/stores/storeDishes";
import { useFieldsStore } from "@/stores/storeFieldData";
import { useModals } from "@/utils/useModals";
import BaseInput from "@/components/ui/BaseInput.vue";
import BaseTextarea from "@/components/ui/BaseTextarea.vue";

const storeRequests = useRequestsStore();
const storeDishes = useDishesStore();
const storeField = useFieldsStore();
const { openModal } = useModals();

const questionnare = ref(null)

onMounted(async () => {
	
	const script = document.createElement("script");
	const scriptPath = "/libs/spotlight.bundle.js";
	script.src = scriptPath;
	questionnare.value.append(script);
});
</script>
<template>
	<div class="questionnare" ref="questionnare">
		<div class="questionnare__apllication">
			<div class="registration">
				<div class="registration__container reg-container">
					<div class="registration__image spotlight" :data-src="storeRequests.userData.survey?.photo">
						<img
							class=""
							width=""
							height=""
							:src="storeRequests.userData.survey?.photo"
							alt="изображение"
						/>
					</div>
					<div class="registration__form">
						<div class="form__block-inputns">
							<div class="form__wrap">
								<BaseInput
									type="text"
									v-model="storeRequests.userData.survey.restaurant"
									:readonly="true"
									placeholder="Ресторан"
									:required="true"
									state-key="restaurant"
								>
									Ресторан
								</BaseInput>
							</div>
							<div class="form__wrap">
								<BaseInput
									type="text"
									v-model="storeRequests.userData.survey.city"
									:readonly="true"
									placeholder="Город"
									:required="true"
									state-key="city"
								>
									Город
								</BaseInput>
							</div>
							<div class="form__wrap">
								<BaseInput
									type="text"
									v-model="storeRequests.userData.survey.restaurant_address"
									:readonly="true"
									placeholder="Адрес"
									:required="true"
									state-key="restaurant_address"
								>
									Адрес ресторана
								</BaseInput>
							</div>
							<div class="form__wrap">
								<BaseTextarea
									v-model="storeRequests.userData.survey.about_myself"
									:readonly="true"
									:max-length="1200"
									state-key="about_myself"
									placeholder="Описание"
									>Расскажите о себе и о своем карьерном пути</BaseTextarea
								>
							</div>
							<div class="form__wrap">
								<BaseTextarea
									v-model="storeRequests.userData.survey.reason"
									:readonly="true"
									:max-length="1200"
									state-key="reason"
									placeholder="Описание"
									>Почему принимаете участие в конкурсе?</BaseTextarea
								>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="questionnare__dishes-list">
			<div class="dishes-list">
				<div
					:class="['dish not-controls']"
					v-for="(dish, index) in storeRequests.userData.survey?.dishes"
					:key="dish.id"
				>
					<div class="dish__box">
						<div class="dish__pic">							
							<div class="dish__image spotlight" :data-src="!!dish.photo_interior ? dish.photo_interior :dish.photo">
								<img
									class="dish__img"
									width="300"
									height="300"
									:src="!!dish.photo_interior ? dish.photo_interior :dish.photo"
									alt="изображение"
								/>
							</div>
						</div>
						<div class="dish__controls">
							<h4 class="dish__name">Блюдо № {{ index + 1 }}</h4>
						</div>
						<BaseTextarea
							class="dish__textarea"
							:readonly="true"
							:max-length="1500"
							:state-key="`message`"
							v-model="dish.description"
							placeholder=""
						>
						Описание блюда / состав / как сочетается с Courvoisier
						</BaseTextarea>
					</div>
				</div>
				<div
					:class="['dish not-controls']"
					v-if="storeRequests.userData.survey?.photo_menu"
				>
					<div class="dish__box">
						<div class="dish__pic">
							<div class="dish__image spotlight" :data-src="storeRequests.userData.survey?.photo_menu">
								<img
									class="dish__img"
									width="300"
									height="300"
									:src="storeRequests.userData.survey?.photo_menu"
									alt="изображение"
								/>
							</div>
						</div>
						<div class="dish__controls">
							<h4 class="dish__name">Меню</h4>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<style lang="scss" scoped>
@use "@/assets/scss/base/vars";

.questionnare {
	width: 100%;
}
.questionnare__apllication {
	margin-bottom: 5.4rem;
	@media (max-width: vars.$x480) {
		margin-bottom: 4rem;
	}
}
.questionnare__desc {
	max-width: 79%;
	font-weight: 400;
	font-size: 1.8rem;
	line-height: 140%;
	margin-bottom: 3.4rem;
	@media (max-width: vars.$m) {
		max-width: 100%;
	}
	@media (max-width: vars.$x480) {
		font-size: 1.6rem;
		line-height: 133%;
		margin-bottom: 2.5rem;
	}
}
.questionnare__dishes-list {
	gap: 20px;
	margin-bottom: 40px;
}
.questionnare__btn-text {
	display: block;
	width: fit-content;
	margin: 3.4rem auto 0;
}
.questionnare__btn {
	margin: 0 auto;
}

.registration {
	width: 100%;
}

.registration__container {
	width: 100%;
	display: grid;
	grid-template-columns: 33.8rem 1fr;
	gap: 2rem;
	align-items: start;
	@media (max-width: vars.$m) {
		grid-template-columns: 1fr;
		justify-items: center;
	}
}
.registration__image {
	padding: 2rem;
	border: 1px dashed var(--red);
	@media (max-width: vars.$m) {
		width: 33.8rem;
	}
	@media (max-width: vars.$x425) {
		width: 100%;
	}
	img {
		width: 100%;
	}
}
.registration__form {
	width: 100%;
}
.dish {
	&:not(:first-child) {
		padding-top: 3.4rem;
	}
	&:not(:last-child) {
		border-bottom: 1px solid rgba(0, 0, 0, 0.1);
		padding-bottom: 3.4rem;
	}

	&.not-controls {
	}
}
.dish__box {
	width: 100%;
	display: grid;
	grid-template-columns: 33.8rem 1fr;
	grid-template-rows: 20px 1fr;
	gap: 2.6rem 2rem;
	align-items: stretch;
	@media (max-width: vars.$m) {
		grid-template-columns: 1fr;
		gap: 20px;
		grid-template-rows: 20px 1fr auto;
		align-items: start;
		justify-items: center;
	}
}
.dish__pic {
	width: 100%;
	grid-column: 1/2;
	grid-row: 1/3;
	aspect-ratio: 1;
	@media (max-width: vars.$m) {
		width: 33.8rem;
		grid-column: 1/2;
		grid-row: 2/3;
	}
	@media (max-width: vars.$x425) {
		width: 100%;
	}
}
.dish__image {
	padding: 2rem;
	border: 1px dashed var(--red);
	&.spotlight {
		height: 100%;
		img {
			height: 100%;
			object-fit: cover;
		}
	}
	img {
		width: 100%;
	}
}
.dish__controls {
	display: flex;
	align-items: center;
	gap: 1.6rem;
	grid-column: 2/3;
	grid-row: 1/2;
	@media (max-width: vars.$m) {
		grid-column: 1/2;
		grid-row: 1/2;
		width: 100%;
	}
}
.dish__name {
	font-family: var(--font-family-md);
	font-weight: 500;
	font-size: 2rem;
	line-height: 120%;
	color: var(--red);
}
.dish__delete-btn {
	font-weight: 400;
	font-size: 1.6rem;
	line-height: 120%;
	color: rgba(29, 29, 27, 0.5);
	border-bottom: 1px solid currentColor;
	@media (hover: hover) {
		&:hover {
			border-color: transparent;
		}
	}
}
.dish__textarea {
	grid-column: 2/3;
	grid-row: 2/3;
	@media (max-width: vars.$m) {
		grid-column: 1/2;
		grid-row: 3/4;
		width: 100%;
	}
}
</style>
